module.exports = __webpack_public_path__ + "static/donusum-8a860f0bba31d71d0fe4bcc4f8ac199c.jpg";